// extracted by mini-css-extract-plugin
module.exports = {"aboutTile":"about-module--aboutTile--381PW","aboutBlock":"about-module--aboutBlock--1fLBr","mrTp26PX":"about-module--mrTp26PX--x5qv6"};